function isDocumentTypeSelected(value: number | null): boolean {
	return value !== null;
}

export default isDocumentTypeSelected;
